// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-013c443f] .center{text-align:center;margin-right:0 !important;margin-left:5px}", ""]);
// Exports
module.exports = exports;
